import '../../scss/blog/blog.scss';
import './load-more';
import './filter';

const BlogRequest = ( btn, cnt, reset = false ) => {
    btn.classList.add('is-loading');

    if( reset ) {
        cnt.innerHTML = '';
        btn.setAttribute('data-page', 0);
        btn.classList.remove('disabled');
    }

    setTimeout(() => {

        fetch( `${ makler_args.ajax_url }?action=${ makler_args.action }` , {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify( {
                nonce: makler_args.nonce,
                per_page: btn.getAttribute('data-per_page') ?? 0,
                page: btn.getAttribute('data-page') ?? 1,
                category: btn.getAttribute('data-category') ?? 0
            } )
        })
        .then((response) => response.json())
        .then((data) => {

            if( data.success === true ) {                
                cnt.innerHTML = cnt.innerHTML + data.return.content;

                btn.setAttribute('data-page', data.return.current);

                if( data.return.found === 0 || data.return.is_last === true ) {
                    btn.classList.add('disabled');
                    console.log('disabled')
                }
            }

            btn.classList.remove('is-loading');
        })
        .catch((error) => {
            // console.error('Error:', error);
        });

    }, 1000);

}

window.BlogRequest = BlogRequest;
